module.exports = __webpack_public_path__ + "img/cp_banner.cab48521.png";